const stripeSyncIssues = {
  count_one: '<1>{{ count }}</1> problème non résolu',
  count_other: '<1>{{ count }}</1> problèmes non résolus',

  actions: 'Actions',
  count: '<1>{{count}}</1> problème(s) non résolu(s)',
  createdAt: 'Créé le',
  dealer: 'Installateur',
  markAsResolved: 'Marquer comme résolu',
  message: 'Message',
  resolved: 'Résolu',
  status: 'Statut',
  syncNumber: 'Numéro de sync',
  syncNumberDescription:
    'Compteur incrémental pour la tentative de synchronisation lors de laquelle le problème a été détecté.',
  title: 'Problèmes de synchronisation Stripe',
  updatedAt: 'Mis à jour le',
  unresolved: 'Non résolu',
};

export default stripeSyncIssues;
